import * as types from './mutation-types';

export default {
  [types.SET_CODIGO_BENEFICIOS](state, payload) {
    state.beneficios = payload;
  },
  [types.SET_CODIGO_BENEFICIO](state, payload) {
    state.beneficio = payload;
  },
  [types.RESET_CODIGO_BENEFICIO](state) {
    state.beneficio.id = null;
    state.beneficio.descricao = null;
    state.beneficio.aliqCredPresumido = 0;
    state.beneficio.CST00 = false;
    state.beneficio.CST10 = false;
    state.beneficio.CST20 = false;
    state.beneficio.CST30 = false;
    state.beneficio.CST40 = false;
    state.beneficio.CST41 = false;
    state.beneficio.CST50 = false;
    state.beneficio.CST51 = false;
    state.beneficio.CST60 = false;
    state.beneficio.CST70 = false;
    state.beneficio.CST90 = false;
  },
};
